import React from "react";
import { Spin } from 'antd';
import loader from "../../assets/images/loader.svg"

const CircularProgress = ({className}) => <div className={`loader ${className}`}>
  {/* <img src={loader} alt="loader"/> */}
  <Spin />
</div>;

export default CircularProgress;